import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
export const useSignifydContext = (): { shouldLoadSignifyd: boolean } => {
    const router = useRouter()
    const [shouldLoadSignifyd, setShouldLoadSignifyd] = useState(false)

    useEffect(() => {
        const currentPath = router.pathname
        if (
            currentPath.startsWith('/checkout') ||
            currentPath.startsWith('/account')
        ) {
            setShouldLoadSignifyd(true)
        } else {
            setShouldLoadSignifyd(false)
        }
    }, [router.pathname])

    return {
        shouldLoadSignifyd
    }
}
